import React, { useEffect } from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { events } from './events';

const ConfirmationModal = ({
  onClickClose,
  onClickContinue,
}: {
  onClickClose: () => void;
  onClickContinue: () => void;
}) => {
  // analytics
  useEffect(() => {
    events.distributeToSpotifyConfirmationScreenView();
  }, []);

  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={() => {
        events.distributeToSpotifyConfirmationExitButtonClicked();
        onClickClose();
      }}
      aria-labelledby="confirmation-distribution-title"
      size="small"
    >
      <Modal.Title id="confirmation-distribution-title">
        You&#39;re almost live!
        <span role="img" aria-label="Tada emoji">
          🎉
        </span>
      </Modal.Title>
      <Modal.Body>
        Your podcast will be available on Spotify shortly. We’ll let you know as
        soon as it’s ready!
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary
          onClick={() => {
            events.distributeToSpotifyConfirmationContinueButtonClicked();
            onClickContinue();
          }}
        >
          Continue
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};

export { ConfirmationModal };
